/*
 * File: OtpField.tsx
 * Project: a-a
 * File Created: Wednesday, 23rd October 2024 10:10:39 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Wednesday, 23rd July 2025 10:11:38 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2024 Mutual Mobile, Mutual Mobile
 */
import React, { useState } from 'react';
import EntryLayoutScreen from '../../shared/EntryLayout/EntryLayout';

import styles from './OtpField.module.css';
import { Link, useNavigate } from 'react-router-dom';
import { useInput } from '../../../customHook/useInput';
import validator from 'validator';
import { AuthService } from '../../../service/auth.service';
import CustomButton from '../../shared/CustomButton/CustomButton';
import zeplinColor from '../../../theme/Color';
import RoutePaths from '../../../routes/RoutePaths';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CustomOTP from '../../shared/CustomOTP/CustomOTP';
import { Constants, Error } from '../../../utilities/constants';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import WifiOffRoundedIcon from '@mui/icons-material/WifiOffRounded';

type OtpFieldProps = {
  user: string;
  otp: string;
  setOtp: React.Dispatch<React.SetStateAction<string>>;
  handleNext: () => void;
};

const OtpField = ({ user, otp, setOtp, handleNext }: OtpFieldProps) => {
  const email = sessionStorage.getItem('reset-user') || '';
  const [alert, setAlert] = useState('');
  let error = false;
  const resendOtp = async () => {
    try {
      const res = await AuthService.forgotPassword({ userName: email });
      console.log(res);
      if (res?.$metadata?.httpStatusCode === 200) {
        // navigate(RoutePaths.ResetPassword)
        // sessionStorage.setItem('reset-user',email)
        // sessionStorage.setItem('next','otp')
        setAlert('Email Sent');
      }
    } catch (err: any) {
      // setError(err?.response?.data?.name.split(/(?=[A-Z])/).splice(0,2).join(' '))
      const message: Error = err?.response?.data?.name || '';
      // if(err?.response?.data?.name===Error.ExpiredCode){
      console.log(Constants.ErrorText[message]);
      error = true;
      setAlert(Constants.ErrorText[message]);
      // }
    }
  };
  const handleDefaultAlert = () => {
    setAlert('');
    error = false;
  };
  const children = (
    <div className={styles['otp-field-input']}>
      <CustomOTP separator={''} value={otp} onChange={setOtp} length={6} />
      <CustomButton
        onClick={handleNext}
        variant='contained'
        disabled={otp.length === 6 ? false : true}
        color={otp.length === 6 ? 'primary' : 'customDisable'}
        style={{ width: '50%', borderRadius: '14px', height: 56 }}
        textStyle={{ color: otp.length === 6 ? zeplinColor.Neutral1 : zeplinColor.Neutral8 }}
        text={'Continue'}
      />
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <p style={{ color: zeplinColor.Neutral9 }}>{'Didn’t receive the email ?'}</p>

        <CustomButton
          disabled={false}
          variant='text'
          text={'Click to resend'}
          textStyle={{ color: zeplinColor.Brand1 }}
          onClick={resendOtp}
        />
      </div>
      <Link to={RoutePaths.Root}>
        <CustomButton
          disabled={false}
          variant='text'
          text={'Back to Log in'}
          icon={<ArrowBackIcon />}
          textStyle={{ color: zeplinColor.Brand1 }}
          onClick={() => {}}
        />
      </Link>
    </div>
  );

  return (
    <EntryLayoutScreen
      header={'Enter confirmation code'}
      subheader={`We've sent a code to ${user}`}
      input={children}
      alternative={''}
      footerText=''
      footerButtonText=''
      icon={
        <div
          style={{
            backgroundColor: zeplinColor.Neutral3,
            borderRadius: '70px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            margin: 'auto',
            width: '80px',
            height: '80px',
            padding: '20px',
          }}
        >
          <img src={'/assets/mail.svg'} width={40} height={40} />
        </div>
      }
      clickAction={() => {}}
      alert={alert}
      error={error}
      handleClose={handleDefaultAlert}
      alertIcon={
        error ? (
          <WifiOffRoundedIcon style={{ color: zeplinColor.Neutral1, width: 18, height: 18 }} />
        ) : (
          <img src='/assets/check-outlined.svg' width={24} height={24} />
        )
      }
    />
  );
};

export default OtpField;
